<p
  [ngStyle]="{ 'text-align': textAlign }"
  [class.hidden]="
    control
      ? control.status === 'DISABLED'
        ? !(control.invalid && control.touched)
        : control.valid || !control.touched
      : false
  "
  class="label validation-text"
>
  <ng-content></ng-content>
</p>
